import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import React from 'react'

import { formatDate } from '../../utils/functions'

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  lineHeight: '32px',
}))

const AsOfDate = React.memo(({ date, formatOverride = 'M/d/yyyy' }) => {
  if (!date) {
    return null
  }

  return (
    <StyledTypography variant="body2" component="h2">
      As of {formatDate(date, formatOverride)}
    </StyledTypography>
  )
})

AsOfDate.displayName = 'AsOfDate'

AsOfDate.propTypes = {
  date: PropTypes.string,
  formatOverride: PropTypes.string,
}

export default AsOfDate
